import { Suspense } from 'react';
import { InvestmentView } from '@/components/InvestmentView';
import { PageSkeleton } from '@/components/PageSkeleton';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';
import { useChatPage } from '@/hooks/useChatPage';

export default function InvestmentsPage() {
  useChatPage('investments');
  return (
    <div data-onboarding-investments-page>
      <AppHeaderConfig hidePeriodPicker />
      <Suspense fallback={<PageSkeleton />}>
        <InvestmentView />
      </Suspense>
    </div>
  );
}
